var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { NavLink } from "react-router-dom";
import { ThemePalette, ThemePaletteState, ThemeShadowSizes } from "../../../theme/_Types";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
import { Div } from "../03-base/Div";
import { Badge } from "../05-atoms/Badge";
import { Button } from "../05-atoms/Button";
import { IconNames } from "../05-atoms/Icon";
import { ComingSoon } from "../09-views/00-blocks/ComingSoon";
var CardContent = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "m-info-card__title" },
            props.title,
            !!props.beta &&
                React.createElement("span", { style: { fontSize: "15px" } },
                    React.createElement(ComingSoon, null))),
        props.description &&
            React.createElement("div", { className: "m-info-card__description" }, props.description),
        props.badgeLabel &&
            React.createElement("div", { style: { width: "115px", marginTop: "5px" } },
                React.createElement(Badge, { theme: {
                        palette: ThemePalette.BRAND_SPECIAL_FIRST,
                    } }, props.badgeLabel)),
        (props.navLink || props.link) &&
            React.createElement(Button, { className: "m-info-card__icon", theme: {
                    palette: !props.selected ? ThemePalette.BRAND_ACCENT : undefined,
                    paletteState: props.selected ? ThemePaletteState.SUCCESS : undefined,
                    shadow: ThemeShadowSizes.TINY,
                }, icon: props.icon ? props.icon : IconNames.ARROW_RIGHT, style: props.style })));
};
var InfoCardComp = function (props) {
    var _a, _b;
    var clazzName = joinClasses("m-info-card", !!props.disabled ? "m-info-card--disabled" : undefined, props.navLink || props.link ? "m-info-card--clickable" : undefined, !!props.beta ? "m-info-card--beta" : undefined, !!props.selected ? "m-info-card--selected" : undefined);
    return (React.createElement(Div, { className: clazzName, theme: {
            palette: (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette) !== null && _b !== void 0 ? _b : ThemePalette.BRAND_ACCENT,
            margin: {
                "": { b: 2, t: 2 },
                "sm": { b: 2, t: 3 },
            },
            shadow: ThemeShadowSizes.SMALL,
        } }, props.navLink ?
        React.createElement(NavLink, { className: "m-info-card__content", to: props.navLink, exact: true }, CardContent(props)) :
        React.createElement("a", __assign({ className: "m-info-card__content" }, props.link), CardContent(props))));
};
export var InfoCard = asThemeConsumer(InfoCardComp);
export var testUtil = {
    CardContent: CardContent,
};
